import dynamic from 'next/dynamic';

type ClientOnlyProps = { children: JSX.Element };

const ClientOnlyWrapper = (props: ClientOnlyProps) => {
  const { children } = props;

  return children;
};

export default dynamic(() => Promise.resolve(ClientOnlyWrapper), {
  ssr: false,
});
